import { useState } from 'react'
import { Link, Navigate } from 'react-router-dom'

import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'
import { getFetchError } from '@/reducers/fetch'
import {
  SEND_RESET_PASSWORD_EMAIL_KEY,
  sendResetPasswordEmail,
} from '@/actions/authActions'
import { TypographyStyles } from '@/styles'
import { Text, Alert, Image, Input, Button, Card } from '@/ui'

const transformErrorMessage = (message: string) =>
  message === 'email must be unique'
    ? 'An account already exists with this email.'
    : message

export const ResetPassword = () => {
  const [email, setEmail] = useState('')
  const auth = useReselector((state) => state.auth.security)
  const dispatch = useAppDispatch()

  const error = useReselector((state) =>
    getFetchError(state, SEND_RESET_PASSWORD_EMAIL_KEY)
  )

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    dispatch(sendResetPasswordEmail({ email: email.toLowerCase() }))
  }

  if (auth.isAuthenticated) {
    return <Navigate to="/dashboard" />
  }

  if (auth.resetPasswordEmailSent) {
    return (
      <div className="finances reset w-full background-app h-full">
        <div className="w-full text-center pt-12 flex flex-col items-center space-y-6">
          <div className="flex justify-center">
            <Image
              src="https://heard-images.s3.us-west-1.amazonaws.com/heard_logo_green_2x.png"
              alt="heard logo"
              height={20}
              width={100}
            />
          </div>

          <Text variant={TypographyStyles.H2}>Please check your email!</Text>

          <Text variant={TypographyStyles.BODY_MD}>
            If an account exists for that email address, you&#39;ll receive a
            password reset link shortly.
          </Text>
        </div>
      </div>
    )
  }

  return (
    <div className="finances reset w-full background-app h-full">
      <div className="w-full text-center pt-12 flex flex-col items-center space-y-6">
        <div className="flex justify-center">
          <Image
            src="https://heard-images.s3.us-west-1.amazonaws.com/heard_logo_green_2x.png"
            alt="heard logo"
            height={20}
            width={100}
          />
        </div>

        <div className="flex justify-center w-full">
          <Card className="w-full md:w-3/4 lg:w-1/2">
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col space-y-4">
                <Text textAlign="center" variant={TypographyStyles.H2}>
                  Reset Your Password
                </Text>
                {error && (
                  <Alert
                    variant="error"
                    title={transformErrorMessage(error.message)}
                    className="mb-4"
                  />
                )}
                <Input
                  placeholder="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <Button
                  id="btn-auth-reset-password-email"
                  type="submit"
                  disabled={!email}
                >
                  Send Reset Email
                </Button>
              </div>
            </form>
          </Card>
        </div>

        <Link to="/login" className="underline text-brand">
          Return to login
        </Link>
      </div>
    </div>
  )
}
